
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './Components/Home/Home.jsx';
import Corporate from './Components/Contact/Corporate.jsx';
import Contact from './Components/Contact/Contact.jsx';
import Flights from './Components/Flights/Flights.jsx';
import About from './Components/About/About.jsx';  
import Tours from './Components/Tour/Tour.jsx';
import Hotels from './Components/Hotels/Hotels.jsx'
import Visa from './Components/Flights/Visa.jsx';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/contact" element={<Contact/>} /> 
         <Route path="/flights" element={<Flights />} /> 
          <Route path="/about" element={<About />} />
        <Route path="/corporate" element={<Corporate />} /> 
        <Route path="/tours" element={<Tours/>} /> 
        
        <Route path="/visa" element={<Visa />} /> 
        <Route path="/hotels" element={<Hotels/>} /> 
      </Routes>
    </BrowserRouter>
  );
}

export default App;
